module.exports = __webpack_public_path__ + "img/engineer123.04bbb72e.png";